/* eslint-disable */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroller/dist/InfiniteScroll';
import { connect } from 'react-redux';

import { getFile } from '@/store/files/actions';
import { getTopicCreByCurUser, getTopics } from '@/store/topics/actions';
import {
  createProfileStudyPlan,
  createProfileUserTopic,
  deleteProfileUserTopic,
  setAvaToCache,
} from '@/store/user-topics/actions';

import { selectTopics as topicsSelect } from '@/store/topics/selectors';
import { selectUsers as usersSelect } from '@/store/users/selectors';

import { FloatButton, Layout, Row, Spin } from 'antd';

import ListItem from '../../../components/MaterialListItem/index';
import CalendarModal from '../../CalendarModal/index.jsx';

import { isCorpCourseWithOrWithoutApprove } from '@shared/utils/topic-utils';

import { createSelector } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import throttle from 'lodash/throttle';
import PT, { object } from 'prop-types';

import css from './styles.module.scss';

import { SCHEDULED } from '@/constants/study-plan-statuses';

const { Content } = Layout;

class MyMaterialTable extends Component {
  static propTypes = {
    cachedFiles: PT.object,
    creBy: PT.number,
    createProfileStudyPlan: PT.func,
    createProfileUserTopic: PT.func,
    currentUser: PT.object,
    deleteProfileUserTopic: PT.func,
    externalLogin: PT.any,
    getFile: PT.func,
    getPhoto: PT.func,
    getTopicCreByCurUser: PT.func,
    getTopics: PT.func,
    handleDeleteClick: PT.func,
    hasMore: PT.bool,
    hideActionButtons: PT.bool,
    isLoading: PT.bool,
    loadMore: PT.func,
    onDeleteClick: PT.func,
    onDeleteClickCatalog: PT.func,
    onFavoriteClick: PT.func,
    onFavoriteClickCatalog: PT.func,
    onStudyPlanClick: PT.func,
    onlyTopic: PT.bool,
    pageNumber: PT.number,
    profileId: PT.number,
    recBy: PT.number,
    setAvaToCache: PT.func,
    topicsByAnotherUser: PT.array,
    total: PT.number,
    user: PT.object,
    userId: PT.number,
  };

  constructor(props) {
    super(props);
    this.reqAvatar = {};
    this.getTopicCreByCurUser = throttle(props.getTopicCreByCurUser, 1300);
    this.state = {
      userId: props.userId,
      calendarModalVisible: false,
      isLoadingFlag: true,
      numberPage: 0,
    };
  }

  componentDidMount() {
    if (this.state.userId) {
      this.getTopicCreByCurUser({ creBy: this.state.userId, page: 0, size: 15 }, true);
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (
      !newProps.hasMore ||
      (!newProps.isLoading && newProps.topicsByAnotherUser && newProps.topicsByAnotherUser.length !== 0)
    ) {
      this.setState({ isLoadingFlag: false });
    } else {
      this.setState({ isLoadingFlag: true });
    }
  }

  loadMore = (page, hasMore) => {
    const { numberPage, userId } = this.state;
    if ((hasMore || this.props.hasMore) && numberPage !== page) {
      this.getTopicCreByCurUser({ creBy: userId, page, size: 15 }, true);
      this.setState({ numberPage: page });
    }
  };

  getFile = (id, uuid, reset) => {
    if (this.reqAvatar[id] && !reset) {
      return null;
    }
    if (this.props.cachedFiles[id] && !reset) {
      return this.props.cachedFiles;
    }
    this.reqAvatar = { ...this.reqAvatar, [id]: true };
    this.props.getFile(uuid, res => {
      this.reqAvatar = { ...this.reqAvatar, [id]: false };
      this.props.setAvaToCache(id, URL.createObjectURL(res));
    });
  };

  handleFavoriteClick = topicId => {
    this.props.createProfileUserTopic(this.props.currentUser.id, topicId, 'anotherMyMaterial', () => {});
  };

  handleDeleteClick = topicId => {
    this.props.deleteProfileUserTopic(topicId, true, true, 'anotherMyMaterial', () => {});
  };

  showCalendarModal = (topicId, type, startDate, topicInfo) => {
    this.setState({
      topicInfo,
      calendarModalVisible: true,
      planningTopicId: topicId,
      planningTopicType: type,
      startDate,
    });
  };

  handleStudyPlanClick = (topicId, planningMonths = [], comment) => {
    for (let i = 0; i < planningMonths.length; i++) {
      this.props.createProfileStudyPlan(
        this.props.currentUser.id,
        topicId,
        planningMonths[i],
        SCHEDULED,
        comment,
        () => {
          this.props.getTopics({}, this.state.page - 1);
          this.handleCalendarCancel();
        },
        true
      );
    }
  };

  handleCalendarCancel = () => {
    this.setState({
      calendarModalVisible: false,
    });
  };

  render() {
    const { t } = this.props;
    const loader = this.props.hasMore && (
      <div key={`loader_${this.props.pageNumber}`}>
        <Spin />
      </div>
    );
    const disabledSelect = this.state.planningTopicType && this.state.planningTopicType.id === 8;
    const list =
      this.props.topicsByAnotherUser &&
      this.props.topicsByAnotherUser.length > 0 &&
      this.props.topicsByAnotherUser.map((item, key) => (
        <ListItem
          key={`${item.id}-${key}`}
          user={item.user}
          topic={item}
          profileId={this.props.profileId}
          typeList='MyMaterial'
          theLast={this.props.topicsByAnotherUser.length - 1 === key}
          checkIsEnd={
            item.type &&
            (item.type.id === 8 || item.type.id === 23) &&
            item.planStatus &&
            !item.planStatus.planStatus &&
            dayjs(`${item?.topic?.endDate} ${item?.topic?.endTime}`).isBefore(dayjs())
          }
          checkCoursePlan={item.type && item.planStatus && !item.planStatus.planStatus}
          onFavoriteClick={this.handleFavoriteClick}
          setNoViewedValue={this.setNoViewedValue}
          cachedFiles={this.props.cachedFiles}
          onStudyPlanClick={this.showCalendarModal}
          onDeleteClick={this.handleDeleteClick}
          page={this.props.pageNumber}
          isExternalLogin={this.props.externalLogin}
          hideActionButtons={this.props.hideActionButtons}
          isAnother
        />
      ));
    return (
      <Content className={css.RecommendedTopic}>
        <Spin spinning={this.state.isLoadingFlag}>
          <Row className={css.Content}>
            {this.props.topicsByAnotherUser && this.props.topicsByAnotherUser.length === 0 ? (
              <div className={css.RecommendedTopic__message}>
                <p>{t('materials')}</p>
              </div>
            ) : (
              <InfiniteScroll
                className={css.InfiniteScroll}
                initialLoad={false}
                loadMore={() => this.loadMore(this.props.pageNumber + 1)}
                hasMore={this.props.hasMore}
                threshold={50}
                loader={loader}
              >
                {list}
              </InfiniteScroll>
            )}
          </Row>
        </Spin>
        <FloatButton.BackTop />
        {this.state.calendarModalVisible && (
          <CalendarModal
            open={this.state.calendarModalVisible}
            onOk={this.handleStudyPlanClick}
            onCancel={this.handleCalendarCancel}
            disabledSelect={disabledSelect}
            dateEvent={dayjs(this.state.startDate, 'D MMMM YYYY')}
            title={!disabledSelect ? t('selectPlan') : t('planingEvent')}
            okText={t('add')}
            planningTopicId={this.state.planningTopicId}
            loading={this.props.isLoading}
            topicInfo={this.state.topicInfo}
            eventTypeId={this.state.planningTopicType && this.state.planningTopicType.id}
            {...(this.state.planningTopicType &&
              this.state.planningTopicType.id === 20 && {
                okText: t('addToPlan'),
                headerFixToModal: true,
              })}
            {...(this.state.planningTopicType &&
              this.state.planningTopicType.id === 8 && {
                okText: t('addToPlan'),
                headerFixToModal: true,
              })}
            hasEvents={this.state.topicInfo && this.state.topicInfo.eventCount !== 0}
            selectMonthEvents={
              this.state.planningTopicType &&
              (isCorpCourseWithOrWithoutApprove(this.state.planningTopicType.id) ||
                this.state.planningTopicType.id === 20)
            }
          />
        )}
      </Content>
    );
  }
}

const mapStateToProps = createSelector([usersSelect, topicsSelect], (users, topics) => ({
  currentUser: users.currentUser,
  userId: users.anotherUser && users.anotherUser.id,
  topicsByAnotherUser: (topics.topicsByAnotherUser && topics.topicsByAnotherUser.elements) || [],
  hasMore: topics.topicsByAnotherUser && topics.topicsByAnotherUser.hasMore,
  pageNumber: topics.topicsByAnotherUser && topics.topicsByAnotherUser.page,
  isLoading: topics.topicsByAnotherUser && topics.topicsByAnotherUser.isLoading,
  cachedFiles: topics.cachedFiles || {},
  total: topics.topicsByAnotherUserTotal,
}));

const mapActionsToProps = {
  getTopicCreByCurUser,
  setAvaToCache,
  createProfileUserTopic,
  deleteProfileUserTopic,
  createProfileStudyPlan,
  getTopics,
  getFile,
};

export default connect(mapStateToProps, mapActionsToProps)(withTranslation('materialList')(MyMaterialTable));
